
import store from '@/store'
import dayjs from 'dayjs'
import { defineComponent } from 'vue'
import { checkoutIdCardNoListTwo, addListInformation } from '@/api/long-insure'
import personnelQueryPopup from '../components/personnel-query-popup.vue'
import AlertBox from '@/components/alert-box.vue'
import ExcelJS from 'exceljs'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import { getCardAge, formTesting, dateFormat, confirm } from '@/utils/util'
import { checkStaffInsureApi, insureEnsurePlanDetailApi, insurePeriodStaffRecordApi, queryListByEnterApi, teminalEnsureApi, onekeyRenewalMonthNotifyApi, ensureBeforeCheckApi, checkCompanyBalance } from '@/api/long-insure-new'
import PeriodInsureInsufficientFeeNotice from '@/components/period-insure-insufficient-fee-notice/index.vue'
import { sdLimitList } from '../utils/config'

export default defineComponent({
  name: 'LongInsureAddSubtract',
  components: {
    personnelQueryPopup,
    AlertBox,
    PeriodInsureInsufficientFeeNotice
  },
  data() {
    return {
      specialAppointisSelect: false,
      showmore: true,
      isopenmore: true,
      specialAppoint: '1、仅承保视频中的对应风险等级工种，其它工种请再提供视频确认2、超风险投保警示:严格按照实际工种对应风险等线进行投保，严禁超风险投保，否则保险公司有权拒赔。如将4类及以上工种投保至1-3类工种属于超风险投保工种',
      insurance: 'add' as string | string[], // 保险状态 add 加保 reduce 减保
      selectionList: [] as string[],
      tioInfo: {} as any,
      date: '',
      isPopup: false,
      addList: [] as any,
      addCloneList: [] as addListInformation[],
      cloneAddList: [] as addListInformation[],
      addPageNum: 0,
      addPageSize: 100000,
      isEditPopup: false,
      isEditTypePopup: '',
      companyDetailList: [] as any, // 派遣单位详细信息列表
      companyDetailId: '',
      companyDetailName: '',
      workTypeList: [] as any[],
      workTypeId: '',
      workTypeName: '',
      fileList: [] as { name: string }[],
      userList: [] as any,
      isManualPopup: false,
      manualName: '',
      manualCode: '',
      isUninsuredPopup: false,
      uninsuredList: [] as any,
      selectedIdCardNo: 0,
      isRemindPopup: false, // 确认提交提醒弹窗
      isSuccessPopup: false, // 加保 或 减保 成功弹窗
      companyList: [] as string[],
      searchType: '',
      isCheckout: false,
      enterErrorList: {},
      companyPlanId: '' as string | string[],
      formErrorList: [] as { name: string; code: string }[],
      isFormError: false,
      datePickerDisabled: false,
      insureRenewal: '',
      isRenew: false,
      isRenewAmount: false,
      testingInsureInfo: {} as {
        price?: number
        priceFour?: number
        priceFive?: number
        needCreateCount?: number
        deductionCount?: number
        needCostFeeMonth?: number
        tomorrowNeedCostFee?: number
        currentBalance?: number
        willEnsureCostFee?: number
      },
      loaded: false,
      // 国家法定节假日列表（包含向后顺延的日期）
      nationalHolidays: [] as string[],
      showInsureNotice: false, //安心保未来三天费用不足的提示弹框
      feeData: {}
    }
  },
  async created() {
    console.log(this.$route.params, 'this.$route.params')
    this.insurance = this.$route.params.type
    // 初始化国家法定节假日列表
    this.nationalHolidays = this.getNationalHolidays()
    // 续保
    if (this.$route.params.echo) {
      this.insureRenewal = this.$route.params.echo as string
      // 当前保司的code
      const code = this.$route.query?.code ?? ''
      // 需要特殊处理的保司code
      if (sdLimitList.includes(code)) {
        this.onNextDay()
      } else {
        await this.onNextMonth()
      }
      await this.getRenewalMonthNotify()
    }
    if (this.$route.params.type === 'add') {
      ; (store.state.titles[2] as string) = '加保'
      // this.date = dayjs().add(1, 'day').format('YYYY-MM-DD')
    } else {
      ; (store.state.titles[2] as string) = '减保'
      // this.date = dayjs().format('YYYY-MM-DD')
    }
    this.getInsureDetailInfo()
    this.companyPlanId = this.$route.params.id
  },
  methods: {
    // 计算默认日期
    calculateDefaultDate(): string {
      let tomorrow = dayjs().add(1, 'day')
      const tomorrowStr = tomorrow.format('YYYY-MM-DD')

      if (this.$route.params.type === 'add') {
        // 加保逻辑：明天不能是国家法定节假日的第二天及节假日结束后的第一天
        // 明天不能是周日和周一，但如果是调休日则可以

        // 检查明天是否是节假日的第二天或结束后的第一天
        const postponedDates = this.getHolidayPostponedDates()
        if (postponedDates.includes(tomorrowStr)) {
          // 如果是节假日结束后的第一天，则给节假日结束后的第二天
          tomorrow = tomorrow.add(1, 'day')
        }
        // 检查是否是周日或周一（但调休日可以）
        let currentDate = tomorrow
        while (true) {
          const dateStr = currentDate.format('YYYY-MM-DD')
          const dayOfWeek = currentDate.day()
          // period_059_QD 额外禁选的日期
          if (this.tioInfo.code === 'period_059_QD' && this.getQdForbiddenDates().includes(dateStr)) {
            currentDate = currentDate.add(1, 'day')
            continue
          }
          // period_047_RB、period_060_RB 特批可选的日期
          if (['period_047_RB', 'period_060_RB'].includes(this.tioInfo.code) && this.getRbAllowedDates().includes(dateStr)) {
            return dateStr
          }
          // 周日或周一，且不是调休工作日
          if ((dayOfWeek === 0 || dayOfWeek === 1) && !this.isCompensatoryWorkday(dateStr)) {
            currentDate = currentDate.add(1, 'day')
            continue
          }

          // 找到合适的日期
          return dateStr
        }
      } else {
        // 减保逻辑：明天不能是国家法定节假日，默认给节假日结束后的第一天
        // 明天不能是周六周日，但如果是调休日则可以

        // 检查明天是否是国家法定节假日
        if (this.isNationalHoliday(tomorrowStr)) {
          // 找到节假日结束后的第一天
          let currentDate = tomorrow
          while (this.isNationalHoliday(currentDate.format('YYYY-MM-DD'))) {
            currentDate = currentDate.add(1, 'day')
          }
          tomorrow = currentDate
        }
      }
    },
    // 国家法定节假日列表（2026年）
    getNationalHolidays() {
      // 这是2026年的国家法定节假日列表
      // 实际项目中应该从后端API获取
      return [
        // 元旦
        '2026-01-01',
        // 春节
        '2026-02-17',
        '2026-02-18',
        '2026-02-19',
        '2026-02-20',
        '2026-02-21',
        '2026-02-22',
        '2026-02-23',
        '2026-02-24',
        // 清明节
        '2026-04-04',
        '2026-04-05',
        '2026-04-06',
        // 劳动节
        '2026-05-01',
        '2026-05-02',
        '2026-05-03',
        '2026-05-04',
        '2026-05-05',
        // 端午节
        '2026-06-19',
        '2026-06-20',
        '2026-06-21',
        // 中秋节
        '2026-09-25',
        '2026-09-26',
        '2026-09-27',
        // 国庆节
        '2026-10-01',
        '2026-10-02',
        '2026-10-03',
        '2026-10-04',
        '2026-10-05',
        '2026-10-06',
        '2026-10-07'
      ]
    },

    // 实际项目中应该从后端API获取
    getCompensatoryAddWorkdays() {
      return [
        '2026-05-10',
        '2026-06-01',
        '2026-09-21', // 国庆节调休补班
        '2026-10-10', // 国庆节调休补班
        '2026-10-11', // 国庆节调休补班
        '2026-11-01'
      ]
    },
    // 实际项目中应该从后端API获取
    getCompensatoryReduceWorkdays() {
      return [
        // 2026年调休工作日（周六）
        '2026-01-03', // 元旦调休补班
        '2026-02-15', // 春节调休补班
        '2026-02-28', // 春节调休补班
        '2026-05-09', // 劳动节调休补班
        '2026-09-20', // 国庆节调休补班
        '2026-09-21', // 国庆节调休补班
        '2026-10-10' // 国庆节调休补班
      ]
    },
    // 检查是否是调休工作日（周六但上班）
    isCompensatoryWorkday(dateStr: string): boolean {
      if (this.$route.params.type === 'add') {
        return this.getCompensatoryAddWorkdays().includes(dateStr)
      } else {
        return this.getCompensatoryReduceWorkdays().includes(dateStr)
      }
    },
    // period_059_QD 在法定节假日禁选范围内特批可选的日期
    getQdAllowedDates(): string[] {
      if (this.$route.params.type === 'add') {
        return ['2026-10-05', '2026-10-06', '2026-10-07', '2026-10-08']
      }
      return ['2026-10-04', '2026-10-05', '2026-10-06', '2026-10-07']
    },
    // period_059_QD 额外禁选的日期
    getQdForbiddenDates(): string[] {
      if (this.$route.params.type === 'add') {
        return ['2026-09-30']
      }
      return ['2026-09-29']
    },
    // period_047_RB、period_060_RB 在原有禁选规则内特批可选的日期
    getRbAllowedDates(): string[] {
      if (this.$route.params.type === 'add') {
        return ['2026-09-27', '2026-09-28']
      }
      return ['2026-09-26', '2026-09-27']
    },
    // period_045_NDS 禁选的日期
    getNdsForbiddenDates(): string[] {
      if (this.$route.params.type === 'add') {
        return ['2026-10-02', '2026-10-03', '2026-10-04', '2026-10-05', '2026-10-06', '2026-10-07', '2026-10-08']
      }
      return ['2026-10-01', '2026-10-02', '2026-10-03', '2026-10-04', '2026-10-05', '2026-10-06', '2026-10-07']
    },
    // 检查是否是国家法定节假日
    isNationalHoliday(dateStr: string): boolean {
      return this.nationalHolidays.includes(dateStr)
    },
    // 检查是否是周六或周日（非调休工作日）
    isWeekend(date: Date): boolean {
      const day = date.getDay()
      const dateStr = dayjs(date).format('YYYY-MM-DD')
      if (day === 6) {
        // 周六：如果是调休工作日，不算周末
        return !this.isCompensatoryWorkday(dateStr)
      }
      // 周日始终算周末
      return day === 0
    },
    // 检查是否是周日或周一
    isSundayOrMonday(date: Date): boolean {
      const day = date.getDay()
      return day === 0 || day === 1
    },
    // 获取节假日向后顺延一天的日期
    getHolidayPostponedDates(): string[] {
      return this.nationalHolidays.map((holiday) => {
        const date = dayjs(holiday).add(1, 'day')
        return date.format('YYYY-MM-DD')
      })
    },
    // 日期禁选函数 控制加保
    disabledDateFn(date: Date): boolean {
      const dateStr = dayjs(date).format('YYYY-MM-DD')
      const today = dayjs().format('YYYY-MM-DD')
      const tenDaysLater = dayjs().add(10, 'day').format('YYYY-MM-DD')

      // period_050_HT、period_051_HT、period_056_SD、period_057_SD、period_058_SD 特殊逻辑
      if (['period_050_HT', 'period_051_HT', ...sdLimitList].includes(this.tioInfo.code)) {
        if (this.$route.params.type === 'add') {
          const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD')
          return dateStr !== tomorrow
        } else {
          return dateStr !== today
        }
      }

      // 加保逻辑
      if (this.$route.params.type === 'add') {
        // 只有今天加未来10天能被选中
        if (dateStr < today || dateStr > tenDaysLater) {
          return true
        }

        // period_045_NDS 禁选的日期
        if (this.tioInfo.code === 'period_045_NDS' && this.getNdsForbiddenDates().includes(dateStr)) {
          return true
        }

        // period_059_QD 在法定节假日禁选范围内特批可选 / 额外禁选的日期
        if (this.tioInfo.code === 'period_059_QD') {
          if (this.getQdForbiddenDates().includes(dateStr)) {
            return true
          }
          if (this.getQdAllowedDates().includes(dateStr)) {
            return false
          }
        }

        // period_047_RB、period_060_RB 在原有禁选规则内特批可选的日期
        if (['period_047_RB', 'period_060_RB'].includes(this.tioInfo.code) && this.getRbAllowedDates().includes(dateStr)) {
          return false
        }

        // 新人保 period_060_RB 周末可以加保 法定节假日不允许加减保
        if (['period_060_RB', 'period_059_QD'].includes(this.tioInfo.code)) {
          const postponedDates = this.getHolidayPostponedDates()
          if (postponedDates.includes(dateStr)) {
            return true
          }
        }

        // 对于 period_047_RB需要禁选周日、周一和法定节假日相关日期
        const planCodeArr = ['period_047_RB']
        if (planCodeArr.includes(this.tioInfo.code)) {
          const dayOfWeek = date.getDay()
          if (dayOfWeek === 0 || dayOfWeek === 1) {
            if (!this.getCompensatoryAddWorkdays().includes(dateStr)) {
              return true
            }
          }

          // 1. 国家法定节假日向后整体向后顺延一天的日期不能被选
          const postponedDates = this.getHolidayPostponedDates()
          if (postponedDates.includes(dateStr)) {
            return true
          }
        }

        return false
      }

      // period_059_QD 减保：额外禁选的日期
      if (this.tioInfo.code === 'period_059_QD' && this.getQdForbiddenDates().includes(dateStr)) {
        return true
      }

      // period_045_NDS 减保：禁选的日期
      if (this.tioInfo.code === 'period_045_NDS' && this.getNdsForbiddenDates().includes(dateStr)) {
        return true
      }

      // 减保逻辑：不禁选，但在选择时进行验证
      return false
    },
    // 监听日期变化，控制减保 时的验证
    onDateChange() {
      // period_059_QD 额外禁选的日期
      if (this.tioInfo.code === 'period_059_QD' && this.date && this.getQdForbiddenDates().includes(this.date)) {
        ElMessage.warning(this.$route.params.type === 'add' ? '此商品不能选择当前时间加保' : '此商品不能选择当前时间减保')
        this.date = ''
        return
      }
      // period_045_NDS 禁选的日期
      if (this.tioInfo.code === 'period_045_NDS' && this.date && this.getNdsForbiddenDates().includes(this.date)) {
        ElMessage.warning(this.$route.params.type === 'add' ? '此商品不能选择当前时间加保' : '此商品不能选择当前时间减保')
        this.date = ''
        return
      }
      // period_047_RB、period_060_RB 在原有禁选规则内特批可选的日期
      if (['period_047_RB', 'period_060_RB'].includes(this.tioInfo.code) && this.date && this.getRbAllowedDates().includes(this.date)) {
        return
      }
      // 对于 period_047_RB 和 period_059_QD方案，需要禁选周日、周一和法定节假日相关日期
      if (['period_047_RB'].includes(this.tioInfo.code)) {
        if (this.$route.params.type !== 'add' && this.date) {
          const dateStr = this.date
          const date = dayjs(dateStr).toDate()
          const dayOfWeek = date.getDay()

          // 检查是否为周日(0)
          if (dayOfWeek === 0) {
            let dateArr = ['2026-09-20', '2026-05-31']
            if (!dateArr.includes(dateStr)) {
              ElMessage.warning('此商品不能选择当前时间减保')
              this.date = ''
              return
            }
          }
          // 检查是否为周六(6)，如果是调休工作日则允许
          if (dayOfWeek === 6) {
            let dateArr = ['2026-05-09', '2026-09-20', '2026-09-21', '2026-10-10']
            // 如果不是调休工作日，则禁止
            if (!dateArr.includes(dateStr)) {
              ElMessage.warning('此商品不能选择当前时间减保')
              this.date = ''
              return
            }
          }
          if (this.isNationalHoliday(dateStr)) {
            ElMessage.warning('此商品不能选择法定节假日')
            this.date = ''
            return
          }
        }
      }
    },
    onFocuse() {
      if (!this.companyDetailId) {
        ElMessage({
          message: '请选择派遣单位',
          type: 'warning'
        })
      } else {
        if (!this.workTypeList.length) {
          ElMessage({
            message: '很抱歉，您当前所选择派遣单位的可用工种，不在该商品的承保范围内，请联系您的专属客户经理。',
            type: 'warning'
          })
        } else {
        }
      }
    },
    downLoadTemp() {
      window.open('https://bullet001.51zidan.com/file/template/投保人员名单模板.xlsx')
    },
    changeisopenmore(i: number) {
      if (i === 1) {
        this.isopenmore = false
      } else {
        this.isopenmore = true
      }
    },
    sglr() {
      this.isManualPopup = true
      this.specialAppointisSelect = false
      this.workTypeId = ''
      this.companyDetailId = ''
      this.manualCode = ''
      this.manualName = ''
    },
    // 显示弹窗弹窗
    onDisplayIsEditPopup(type: string) {
      this.specialAppointisSelect = false
      this.isEditTypePopup = type
      this.isEditPopup = true
      if (type === 'batch') {
        this.companyDetailList = []
        this.workTypeList = []
        this.companyDetailId = ''
        this.workTypeId = ''
      }
    },
    // 基本信息
    async getInsureDetailInfo() {
      const result = await insureEnsurePlanDetailApi({
        companyPlanId: this.$route.params.id,
        yearMonth: ''
      })
      if (result.insurePlanType === 1) {
        result.type = 4
      } else {
        if (result.effectType === 1) {
          result.type = 3
        }
        if (result.effectType === 2) {
          result.type = 5
        }
      }
      this.tioInfo = result
      console.log(result, 'resultresultresultresultresult')
      if (result.code === 'period_015_gwy') {
        this.datePickerDisabled = true
        if (this.$route.params.type === 'add') {
          this.date = dayjs().add(1, 'day').format('YYYY-MM-DD')
          ElMessage({
            message: '此商品加保时间不可修改',
            type: 'warning'
          })
        } else {
          this.date = dayjs().format('YYYY-MM-DD')
          ElMessage({
            message: '此商品减保时间不可修改',
            type: 'warning'
          })
        }
      } else if (!this.$route.params.echo) {
        //  非续保
        if (['period_050_HT', 'period_051_HT', ...sdLimitList].includes(result.code)) {
          if (this.$route.params.type === 'add') {
            this.date = dayjs().add(1, 'day').format('YYYY-MM-DD')
          } else {
            this.date = dayjs().format('YYYY-MM-DD')
          }
        } else if (this.$route.params.type === 'add') {
          if (['period_047_RB', 'period_059_QD'].includes(result.code)) {
            this.date = this.calculateDefaultDate() // 为 period_047_RB period_059_QD方案设置默认日期
          } else {
            this.date = result.type === 5 ? dayjs().format('YYYY-MM-DD') : dayjs().add(1, 'day').format('YYYY-MM-DD')
          }
        } else {
          this.date = dayjs().format('YYYY-MM-DD')
        }
        // period_045_NDS 默认日期若落在禁选范围内则清空，由用户手动选择
        if (result.code === 'period_045_NDS' && this.getNdsForbiddenDates().includes(this.date)) {
          this.date = ''
        }
      }
    },
    // 在线选择
    onlineSelection() {
      this.isPopup = true
    },
    // 减保复选框
    checkMaterialStatus(row: any, column: any, cellValue: any, index: any) {
      // this.addList.filter(item => item.errMsg)
      if (row.errMsg === '未投保') {
        // eslint-disable-next-line no-unused-expressions
        return false
      } else {
        return true
      }
    },
    // 减保样式变化
    reduceTable(row: any) {
      if (row.row.errMsg === '未投保') {
        return 'background-color: rgba(230,230,230,0.1);' // 修改的样式
      } else {
        return 'color: #000000'
      }
    },
    // 减保未投保排序
    changeSort(row: any) {
      // eslint-disable-next-line no-constant-condition
      const nums1 = '未投保' ? 1 : 0
      const nums2 = 0
      return nums1 - nums2
    },
    // 在线选择完成
    async insureComplete(event: addListInformation[]) {
      event.forEach((item: addListInformation, index: number) => {
        event[index].joinType = 1
      })
      this.addList.push(...event)
      this.addCloneList.push(...event)
      if (this.$route.params.type === 'reduce') {
        this.addList.sort((a: any, b: any) => {
          return (b.errMsg ? 1 : 0) - (a.errMsg ? 1 : 0)
        })
      }
      // 去重
      for (let i = 0; i < this.addList.length; i++) {
        for (let j = i + 1; j < this.addList.length; j++) {
          if (this.addList[i].idCardNo === this.addList[j].idCardNo) {
            this.addList.splice(j, 1)
            j = j - 1
          }
        }
      }
      await this.interceptList()
      this.isPopup = false
      this.preparationRecord()
    },
    // 筛选公司列表
    preparationRecord() {
      this.searchType = ''
      // this.companyList = []
      // this.addList = this.addCloneList
      const arr = this.addCloneList
        .map((item: { serveCompanyName: string }) => {
          return item.serveCompanyName
        })
        .filter((n: null | string) => {
          return n
        })
      this.companyList = arr.reduce(function (prev: string[], next: string) {
        prev.indexOf(next) === -1 && prev.push(next)
        return prev
      }, [])
    },
    // 截取数据
    interceptList() {
      this.cloneAddList = this.addList.slice((this.addPageNum ? this.addPageNum - 1 : 0) * this.addPageSize, (this.addPageNum ? this.addPageNum : this.addPageNum + 1) * this.addPageSize)
    },
    // 单个删除
    async deletePersonnel(idCardNo: string) {
      this.addList = this.addList.filter((item: { idCardNo: string }) => item.idCardNo !== idCardNo + '')
      // await this.interceptList()
      this.$message.success('删除成功！')
      this.addCloneList = this.addCloneList.filter((item: { idCardNo: string }) => item.idCardNo !== idCardNo + '')
      this.preparationRecord()
    },
    // 批量删除
    async batchDelete() {
      this.selectionList.forEach((item: string, index: number) => {
        this.addList = this.addList.filter((ite: { idCardNo: string }) => item + '' !== ite.idCardNo + '')
        this.addCloneList = this.addCloneList.filter((ite: { idCardNo: string }) => item + '' !== ite.idCardNo + '')
      })
      // this.addCloneList = this.addList
      this.preparationRecord()
      this.$message.success('批量删除成功！')
    },
    // 勾选或
    handleSelectionChange(event: addListInformation[]) {
      this.selectionList = event.map((item: addListInformation) => {
        return item.idCardNo
      })
    },
    // 编辑人员信息
    async editPersonnelInfo(id: number, type: string, row: any) {
      console.log(44444, row)
      this.specialAppointisSelect = false
      this.companyDetailId = row.serveCompanyId
      this.companyDetailList = [
        {
          serveCompanyName: row.serveCompanyName,
          serveCompanyId: row.serveCompanyId
        }
      ]

      this.workTypeId = row.occupationId
      this.workTypeList = row.occupationList || []

      //   if (!row?.occupationList?.length) {
      await this.getCompanyDetailList()
      const cur = this.companyDetailList.find((i: any) => i.serveCompanyId === row.serveCompanyId)
      if (cur) {
        this.workTypeList = cur.occupationList
      }
      //   }

      this.isEditTypePopup = type
      this.selectedIdCardNo = id
      const userInfo = this.addList.filter((item: addListInformation) => this.selectedIdCardNo + '' === item.idCardNo)
      const { userName, idCardNo } = userInfo[0]
      this.manualName = userName
      this.manualCode = idCardNo
      this.isEditPopup = true
    },
    // 获取派遣单位详细信息
    async getCompanyDetailList() {
      this.loaded = false
      const result = await queryListByEnterApi({
        insureCompany: this.tioInfo.code,
        planCode: this.tioInfo.planCode
      })
      this.loaded = true
      this.companyDetailList = result
    },
    // 选择派遣单位
    async onSelectCompany(e: any) {
      // let result: any = await getsaasCompanyinfoapi({ planId: this.$route.params.id })
      this.specialAppointisSelect = false
      this.companyDetailList.forEach((item: any, i: number) => {
        if (e === item.serveCompanyId) {
          if (item.isBlacklist || item.isForbidden) {
            this.companyDetailId = ''
            // } else if (item.area === '天津' && this.tioInfo.insurCompany === 'period_006_gyas') {
            // } else if (item.area === '天津' && !result.isWhitelist && this.tioInfo.code === 'period_006_gyas') {
          } else if (item.area === '天津' && this.tioInfo.code === 'period_006_gyas') {
            ElMessage.warning('抱歉，当前商品不支持该（天津）地区投保')
            this.companyDetailId = ''
          } else {
            this.specialAppoint = '1、仅承保视频中的对应风险等级工种，其它工种请再提供视频确认2、超风险投保警示:严格按照实际工种对应风险等线进行投保，严禁超风险投保，否则保险公司有权拒赔。如将4类及以上工种投保至1-3类工种属于超风险投保工种'
          }
        }
      })
      if (this.companyDetailId) {
        const arr: any = this.companyDetailList.filter((item: { serveCompanyId: string | number; occupationList: any }) => {
          if (item.serveCompanyId === this.companyDetailId) {
            return item
          }
        })
        if (!arr[0].occupationList?.length) {
          ElMessage.warning('很抱歉，您当前所选择派遣单位的可用工种，不在该商品的承保范围内，请联系您的专属客户经理。')
        }
        this.workTypeList = arr[0].occupationList
        this.workTypeId = ''
      } else {
        this.workTypeList = []
        this.workTypeId = ''
      }
    },
    // 取消更改
    onCancelModification() {
      this.manualName = ''
      this.manualCode = ''
      this.workTypeList = []
      this.isEditPopup = false
    },
    // 确定更改
    async onConfirmModification() {
      if (!this.specialAppointisSelect && this.specialAppoint) {
        ElMessage({
          message: '请勾选特别约定',
          type: 'warning'
        })
      } else if (!this.workTypeId) {
        ElMessage({
          message: '请选择工种',
          type: 'warning'
        })
      } else {
        // 多选编辑
        const company: any = this.companyDetailList.filter((item: any) => item.serveCompanyId === this.companyDetailId)
        const workType: any = this.workTypeList.filter((item: any) => item.occupationId === this.workTypeId)

        console.log(1111, workType, this.workTypeList, this.addList)
        if (this.isEditTypePopup === 'batch') {
          this.selectionList.forEach((item: string) => {
            this.addList.forEach((ite: addListInformation, index: number) => {
              if (item === ite.idCardNo) {
                this.addList[index].serveCompanyName = company[0].serveCompanyName
                this.addList[index].occupationName = workType[0].occupationName
                this.addList[index].serveCompanyId = this.companyDetailId
                this.addList[index].occupationId = this.workTypeId
                this.addList[index].level = workType[0].occupationLevel
                this.addList[index].occupationList = this.workTypeList
                this.addList[index].specialAppoint = this.specialAppoint
                // this.addList[index].userName = this.manualName
                // this.addList[index].idCardNo = this.manualCode
              }
            })
          })
          this.addList.sort((a: any, b: any) => {
            return (a.errMsg ? 1 : 0) - (b.errMsg ? 1 : 0)
          })
          this.isEditPopup = false
          this.companyDetailList = []
          this.workTypeList = []
          this.companyDetailId = ''
          this.workTypeId = ''
        } else {
          // 单选编辑
          const loading = await ElLoading.service({
            fullscreen: true,
            text: '姓名身份证校验中...'
          })
          // 身份证号姓名校验
          const checkoutIdCardNoResTwo = await checkoutIdCardNoListTwo([
            {
              userName: this.manualName,
              idCardNo: this.manualCode
            }
          ])
          if (checkoutIdCardNoResTwo.code === 1) {
            //  弹窗展示错误人员
            this.$message.error(checkoutIdCardNoResTwo.data[0].msg as string)
            await loading.close()
            return
          }
          this.addList.forEach((ite: addListInformation, index: number) => {
            if (this.selectedIdCardNo + '' === ite.idCardNo) {
              // 只有加保才需要 赋值 工种名字
              if (this.insurance === 'add') {
                this.addList[index].serveCompanyName = company[0].serveCompanyName
                this.addList[index].occupationName = workType[0].occupationName
                this.addList[index].level = workType[0].occupationLevel
                this.addList[index].serveCompanyId = this.companyDetailId
                this.addList[index].occupationId = this.workTypeId
              }
              this.addList[index].userName = this.manualName
              this.addList[index].specialAppoint = this.specialAppoint
              this.addList[index].idCardNo = this.manualCode.replace(/x/g, 'X')
            }
          })
          if (this.$route.params.type === 'reduce') {
            const test = this.addList.map((item: any) => {
              return {
                userName: item.userName,
                idCardNo: item.idCardNo
              }
            })
            const checkoutIdCardNoRes = await checkStaffInsureApi({
              companyPlanId: Number(this.$route.params.id),
              workerInfoList: test
            })
            for (let i = 0; i < this.addList.length; i++) {
              for (let j = i + 1; j < this.addList.length; j++) {
                if (this.addList[i].idCardNo === this.addList[j].idCardNo) {
                  this.addList.splice(j, 1)
                  j = j - 1
                }
              }
            }
            if (checkoutIdCardNoRes.errorList.length > 0) {
              for (let i = 0; i < checkoutIdCardNoRes.errorList.length; i++) {
                for (let j = 0; j < this.addList.length; j++) {
                  if (checkoutIdCardNoRes.errorList[i]?.idCardNo === this.addList[j]?.idCardNo) {
                    this.addList[j].errMsg = '未投保'
                    i++
                  } else {
                    this.addList[j].errMsg = ''
                  }
                }
              }
            } else {
              for (let j = 0; j < this.addList.length; j++) {
                this.addList[j].errMsg = ''
              }
            }

            this.addList.sort((a: any, b: any) => {
              return (b.errMsg ? 1 : 0) - (a.errMsg ? 1 : 0)
            })
          }

          this.isEditPopup = false
          this.companyDetailList = []
          this.workTypeList = []
          this.companyDetailId = ''
          this.workTypeId = ''
        }
        // this.addCloneList = this.addList
        await this.preparationRecord()
      }
    },
    search() {
      if (this.searchType !== '') {
        this.addList = this.addCloneList
        const arr = this.addList.filter((item: addListInformation) => item.serveCompanyName === this.companyList[Number(this.searchType)])
        this.addList = arr
      } else {
        return (this.addList = this.addCloneList)
      }
    },
    onReset() {
      this.searchType = ''
      this.addList = this.addCloneList
    },
    close() {
      this.enterErrorList = {}
    },
    // 上传
    async onUpFile(file: File) {
      console.log(77777, file)
      const loading = await ElLoading.service({
        fullscreen: true,
        text: '名单信息校验中...'
      })
      let userList = [] as {
        userName: string
        idCardNo: string
        serveCompanyName: string
        occupationName: string
        joinType: number
        errMsg?: string
      }[]
      const reader = new FileReader()
      const errorList = [] as any
      reader.onload = async (e) => {
        userList = await this.getExcelData(e).catch(async (err: { message: string }) => {
          await loading.close()
          throw new Error(err.message)
        })

        this.formErrorList = this.formErrorList.filter((item) => item.name)
        // if (this.formErrorList.length > 0) {
        //   // formErrorList: [] as string[],
        //   // isFormError: false
        //   this.isFormError = true
        //   // this.$message.error(errorList.toString() + ',表单格式错误')
        //   await loading.close()
        //   // return
        // }

        const staffList = userList.map(
          (
            item: {
              idCardNo: string
              joinType: number
              serveCompanyName: string
              userName: string
            },
            index: number
          ) => {
            return {
              userName: item.userName,
              idCardNo: item.idCardNo
              // index: index + 1
            }
          }
        )
        if (this.$route.params.type === 'add') {
          const verification = await checkoutIdCardNoListTwo(
            userList.map((item, index) => {
              return {
                userName: item.userName,
                idCardNo: item.idCardNo,
                index: index + 1
              }
            })
          )
          this.enterErrorList = verification.data
          // if (verification.code === 1) {
          //     this.enterErrorList = verification.data
          //     return
          // }
          if (verification.data) {
            return
          } else {
            this.userList = userList
          }
          // this.userList = userList
          // this.handleCurrentChange(1)
        } else {
          const verificationTwo = await checkoutIdCardNoListTwo(
            userList.map((item, index) => {
              return {
                userName: item.userName,
                idCardNo: item.idCardNo,
                index: index + 1
              }
            })
          )
          this.enterErrorList = verificationTwo.data
          if (verificationTwo.data) {
            return
          }

          const verification = await checkStaffInsureApi({
            companyPlanId: Number(this.$route.params.id),
            workerInfoList: staffList
          })
          // eslint-disable-next-line no-unused-expressions
          for (let i = 0; i < verification.errorList.length; i++) {
            for (let j = 0; j < userList.length; j++) {
              if (verification.errorList[i].idCardNo === userList[j].idCardNo) {
                userList[j].errMsg = '未投保'
              }
            }
          }
        }
        const unit = await queryListByEnterApi({
          insureCompany: this.tioInfo.code,
          planCode: this.tioInfo.planCode
        })
        const name: {
          serveCompany: any
          name: any
          occupationId: number | null
          serveCompanyId: number | null
          occupationList: []
        }[] = []

        unit?.forEach?.((item: any) => {
          if (item.occupationList.length === 1) {
            // occupationId:
            name.push({
              serveCompany: item?.serveCompanyName,
              name: item.occupationList[0].name,
              occupationId: item?.occupationList[0].occupationId,
              serveCompanyId: item?.serveCompanyId,
              occupationList: item?.occupationList
            })
          } else {
            name.push({
              serveCompany: item?.serveCompanyName,
              name: null,
              occupationId: null,
              serveCompanyId: item?.serveCompanyId,
              occupationList: item?.occupationList
            })

            if (this.tioInfo.type === 3) {
              item.occupationList = item.occupationList.filter((item: any) => {
                return item.level !== '5'
              })
            }
            const result = item.occupationList.sort((a: any, b: any) => {
              return b.level - a.level
            })
            // item.occupationList.sort((item:any) => {
            //     item.occupationList[0].level
            // })
            // name.push(serveCompany:result[0].)
            name[name.length - 1].name = result[0]?.name
            name[name.length - 1].occupationId = result[0]?.occupationId
          }
          return name
        })
        userList.forEach((item: any) => {
          const curIndex = name.findIndex((i) => item.serveCompanyName === i.serveCompany)
          if (curIndex !== -1) {
            item.serveCompanyId = name[curIndex].serveCompanyId
            item.occupationList = name[curIndex].occupationList
            if (item.occupationName) {
              // 将工种和（）()过滤掉
              const curOcpation = item.occupationName.replace(/[\(|（]\d\W[\)|）]/g, '').replace(/((\(|（)|(\)|）))/g, '')
              const idx = name[curIndex].occupationList.findIndex((j: any) => {
                const occupationName = j.occupationName.replace(/[\(|（]\d\W[\)|）]/g, '').replace(/((\(|（)|(\)|）))/g, '')
                console.log(321321, occupationName, curOcpation)
                return occupationName === curOcpation
              })
              if (idx !== -1) {
                item.occupationId = (name[curIndex].occupationList[idx] as any).occupationId
                item.occupationName = (name[curIndex].occupationList[idx] as any).occupationName
                item.level = (name[curIndex].occupationList[idx] as any).occupationLevel
              }
            }
          }
          // name.map((items: any) => {
          //   if (
          //     item.serveCompanyName &&
          //     item.serveCompanyName === items.serveCompany
          //   ) {
          //     item.occupationName = items.name
          //     item.occupationId = items.occupationId
          //     item.serveCompanyId = items.serveCompanyId
          //     return item
          //   }
          //   return item
          // })
        })
        // if(userList.)
        this.userList = userList

        console.log(666666, this.userList)
        //       as [{
        //   errMsg: string
        //   idCardNo: string
        //   userName: string
        // }]
        // .errorList

        // if (verification.code === 1) {
        //     this.enterErrorList = verification.data
        //     return
        // }

        // this.userList = userList
        // this.handleCurrentChange(1)
        // 校验通过

        console.log(444, this.userList)

        await loading.close()
        this.addList.push(...this.userList)

        console.log(9999, this.addList)
        for (let i = 0; i < this.addList.length; i++) {
          for (let j = i + 1; j < this.addList.length; j++) {
            if (this.addList[i].idCardNo === this.addList[j].idCardNo) {
              this.addList.splice(j, 1)
              j = j - 1
            }
          }
        }
        this.addList.sort((a: any, b: any) => {
          return (b.errMsg ? 1 : 0) - (a.errMsg ? 1 : 0)
        })
        this.addCloneList = this.addList
        this.interceptList()
        await this.preparationRecord()
      }
      reader.readAsBinaryString(file)
      this.fileList.push({
        name: file.name
      })
    },

    async getExcelData(e) {
      return new Promise(async (resolve, reject) => {
        const workbook = new ExcelJS.Workbook()
        await workbook.xlsx.load((e.target as FileReader).result as ArrayBuffer)
        const userList: any = []
        try {
          workbook.getWorksheet(1).eachRow(async (item, index) => {
            // 单个检验表格文字是否正常
            const arrError = formTesting(item.getCell(1).value as any, item.getCell(2).value as any) as any
            if (arrError === false) {
              this.$message.error(`表格第${index}行有内容格式错误，请检查`)
              reject(false)
            }
            this.formErrorList.push(arrError)
            if (index <= 1) {
              return item
            }
            userList.push({
              userName: arrError.name || (item.getCell(1).value as string)?.trim?.(),
              idCardNo: arrError.code || (item.getCell(2).value as string).replace(/x/g, 'X')?.trim?.(),
              serveCompanyName: (item.getCell(3).value as string)?.trim?.(),
              occupationName: (item.getCell(4).value as string)?.trim?.(),
              joinType: 2
            })
          })
          resolve(userList)
        } catch (error) {
          ElMessageBox.confirm('读取表格数据失败，请检查模板格式是否正确？请重新下载模板文件进行导入', {
            title: '提示',
            type: 'warning',
            confirmButtonText: '确定',
            showCancelButton: false
          })
          console.log(1111, error)
          reject(false)
        }
      })
    },

    // 手动录入
    async onManualEntry() {
      this.manualName = this.manualName.replace(/\s*/g, '')
      this.manualName = this.manualName.replace(/\./g, '·')
      this.manualCode = this.manualCode.replace(/\s*/g, '')
      this.manualCode = this.manualCode.replace(/x/g, 'X')
      if (!this.specialAppointisSelect && this.specialAppoint) {
        ElMessage({
          message: '请勾选特别约定',
          type: 'warning'
        })
        return
      }
      if (!this.manualCode) {
        this.$message.error('请输入身份证')
        return
      }
      const age = getCardAge(this.manualCode)
      if (age < 16) {
        this.$message.error('小于16岁不可投保')
        return
      }
      if (!this.manualName) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.workTypeId && this.insurance === 'add') {
        this.$message.error('请选择工类')
        return
      }
      if (!this.companyDetailId && this.insurance === 'add') {
        this.$message.error('请输入派遣单位')
        return
      }
      const loading = await ElLoading.service({
        fullscreen: true,
        text: '姓名身份证校验中...'
      })
      let errMsg = ''
      if (this.$route.params.type === 'reduce') {
        // 身份证号姓名校验
        const checkoutIdCardNoResTwo = await checkoutIdCardNoListTwo([
          {
            userName: this.manualName,
            idCardNo: this.manualCode
          }
        ])
        if (checkoutIdCardNoResTwo.code === 1) {
          this.$message.error(checkoutIdCardNoResTwo.data[0].msg as string)
          await loading.close()
          return
        }

        // 身份证号姓名校验
        const checkoutIdCardNoRes = await checkStaffInsureApi({
          companyPlanId: Number(this.$route.params.id),
          workerInfoList: [
            {
              userName: this.manualName,
              idCardNo: this.manualCode
            }
          ]
        })
        errMsg = checkoutIdCardNoRes.errorList[0]?.errMsg
      } else {
        // 身份证号姓名校验
        const checkoutIdCardNoRes = await checkoutIdCardNoListTwo([
          {
            userName: this.manualName,
            idCardNo: this.manualCode
          }
        ])
        if (checkoutIdCardNoRes.code === 1) {
          this.$message.error(checkoutIdCardNoRes.data[0].msg as string)
          await loading.close()
          return
        }
      }

      if (this.insurance === 'add') {
        var company: any = this.companyDetailList.filter((item: any) => item.serveCompanyId === this.companyDetailId)
        var workType: any = this.workTypeList.filter((item: any) => item.occupationId === this.workTypeId)
      }
      console.log(this.workTypeId, this.workTypeList, this.insurance, 'ihafuiuhsauhigf')
      const arr = this.addList
        .map((item: any) => {
          if (item.idCardNo === this.manualCode) {
            return item
          }
        })
        .filter((n: any) => n)
      if (arr.length > 0) {
        this.$message.error('列表中已有该人员')
        return
      }
      await this.addList.push({
        userName: this.manualName,
        idCardNo: this.manualCode,
        // eslint-disable-next-line no-undef
        errMsg: this.insurance === 'reduce' && errMsg ? errMsg : '',
        serveCompanyName: this.insurance === 'add' ? company[0].serveCompanyName : '',
        occupationName: this.insurance === 'add' ? workType[0].occupationName : '',
        joinType: 2,
        level: this.insurance === 'add' ? workType[0].occupationLevel : '',
        serveCompanyId: this.companyDetailId,
        occupationId: this.workTypeId,
        specialAppoint: this.specialAppoint
      })
      this.addList.sort((a: any, b: any) => {
        return (b.errMsg ? 1 : 0) - (a.errMsg ? 1 : 0)
      })
      this.addCloneList = this.addList
      await this.interceptList()
      // companyDetailList workTypeList
      this.isManualPopup = false
      this.companyDetailList = []
      this.workTypeList = []
      this.companyDetailId = ''
      this.workTypeId = ''
      this.preparationRecord()
    },
    // 加保接口
    async insureAdd() {
      let isAdopt = false
      this.addList.forEach((item: addListInformation) => {
        if (!item.occupationId) {
          isAdopt = true
        }
      })
      if (isAdopt) {
        this.$message.error('当前有人未设置工种,或工种设置不正确,请重新设置')
        return
      }
      const result = await insurePeriodStaffRecordApi({
        companyPlanId: this.$route.params.id,
        insureStartDay: this.tioInfo.insurePlanType != 2 ? this.date : dayjs().format('YYYY-MM-DD HH:mm:ss'),
        staffList: this.addList,
        continuedMonth: 1
      })
      this.isRenew = false
      // 重复投保
      if (!result.isSuccess && result.code === 501) {
        this.isRemindPopup = false
        this.enterErrorList = result.errorList.map((i) => {
          return {
            ...i,
            msg: '当前被保人已经在保'
          }
        })
        return
      }

      if (result.code === 1 && result.errorList.length > 0) {
        this.isRemindPopup = false
        this.enterErrorList = result.errorList
        return
      }
      if (!result.isEnoughBalance && result.isSuccess === false) {
        this.$message.error('余额不足')
        return
      }
      this.$message.success('加保成功')
      this.isSuccessPopup = true
      this.initFeeData()
    },
    // 减保
    async insureReduce() {
      let arr = [] as any
      this.addList.forEach((item: { userName: string; idCardNo: string; errMsg?: string }) => {
        arr.push({
          userName: item.userName,
          idCardNo: item.idCardNo,
          errMsg: item.errMsg
        })
      })
      arr = arr.filter((item: any) => !item.errMsg)
      // 减保前的 校验 检验他是否在保
      const checkResult = await checkStaffInsureApi({
        companyPlanId: this.$route.params.id,
        workerInfoList: arr
      })
      if (checkResult.errorList.length === 0) {
        const idS = [] as number[]
        checkResult.correctList.forEach((item: { id: number }) => {
          idS.push(item.id)
        })
        const result = await teminalEnsureApi({
          companyPlanId: this.$route.params.id,
          insureEndDay: this.date,
          ids: idS
        })
        this.$message.success('减保成功')
        this.isUninsuredPopup = false
        this.isSuccessPopup = true
      } else {
        this.isUninsuredPopup = true
        this.uninsuredList = checkResult.errorList
      }
      // const result = await insureReduce({})
    },
    // 关闭表格弹窗
    onFormError() {
      this.formErrorList = []
    },
    onNextMonth() {
      const time = new Date()
      const year = time.getFullYear()
      const month = time.getMonth() + 2
      this.date = dateFormat('YYYY-mm', new Date((month === 13 ? year + 1 : year) + '-' + (month === 13 ? '01' : month))) + '-01'
      console.log(this.date, 'fsyhusdgyusdgyjhu')
      this.datePickerDisabled = true
    },
    onNextDay() {
      const nextDay = dayjs().add(1, 'day').format('YYYY-MM-DD')
      this.date = nextDay
      this.datePickerDisabled = true
    },
    // 续保列表回显
    async getRenewalMonthNotify() {
      const result = await onekeyRenewalMonthNotifyApi({
        planId: this.$route.params.id
      })
      // addList
      const arr = result.staffList.map((item: { userName: string; occupationLevel: number; idCardNo: string; occupationId: number; occupationName: string; serveCompanyId: number; companyPlanName: string; serveCompanyName: string }) => {
        return {
          idCardNo: item.idCardNo,
          joinType: 1,
          level: item.occupationLevel,
          occupationId: item.occupationId,
          occupationName: item.occupationName,
          serveCompanyId: item.serveCompanyId,
          serveCompanyName: item.serveCompanyName,
          userName: item.userName
        }
      })
      this.addList = arr
    },
    // 一键续保前置条件
    async onTestingInsure() {
      this.insureAdd()
      /**
       * 2026-09-09
       * 叶铭强烈要求不要调这个接口让注掉直接调最终续保的接口
       * 现在即使有errorList也不会弹框提示了
       */
      // const result = await ensureBeforeCheckApi({
      //   companyPlanId: Number(this.$route.params.id),
      //   insureStartDay: this.date,
      //   staffList: this.addList
      // })
      // this.testingInsureInfo = result
      // if (result.errorList?.length > 0) {
      //   this.enterErrorList = result.errorList
      // } else {
      //   this.isRenew = result.isSuccess
      //   this.isRenewAmount = !result.isSuccess
      // }
    },
    // 获取未来三天保费的数据
    async initFeeData() {
      const res = await checkCompanyBalance()
      console.log(1234, res)
      this.showInsureNotice = !res.isEnoughForThreeDays
      this.feeData = res
    }
  }
})
